import type { ReviewThreadListItemModel } from "@/api/cle-api";

import { ReviewThreadTopPanel } from "./ReviewThreadTopPanel";

interface EvidenceReviewThreadTopPanelProps {
  reviewThread: ReviewThreadListItemModel | null | undefined;
  ownerUserId: string;
}

export const EvidenceReviewThreadTopPanel = ({
  reviewThread,
  ownerUserId,
}: EvidenceReviewThreadTopPanelProps) => {
  if (!reviewThread) {
    return null;
  }

  return (
    <ReviewThreadTopPanel
      threadId={reviewThread.id}
      thread={reviewThread}
      ownerUserId={ownerUserId}
    />
  );
};
